import React from "react";

export const CompanyContext = React.createContext<number | undefined>(undefined);
